import StatusLabel from './StatusLabel';
import {
  EvLockerAction,
  EvLockerActionStatus,
  EvLockerStatus,
} from '@app/typings/services/winnonie/evlockers';
import {
  NiuBatteryStatus,
  NiuChargerStatus,
  UniversalBatteryStatus,
  UniversalChargerStatus,
} from '@app/typings/services/winnonie/battery';
import { StationAction, StationStatus } from '@app/typings/services/winnonie/station';

export const SetUpperCase = (message: string) => {
  return (
    message.charAt(0).toUpperCase() +
    message
      .replaceAll('_' || '-', ' ')
      .slice(1)
      .toLocaleLowerCase()
  );
};

export const getStationStatusColor = (status?: StationStatus) => {
  switch (status) {
    case StationStatus.ACTIVE:
      return <StatusLabel color="green">{SetUpperCase(StationStatus.ACTIVE)}</StatusLabel>;
    case StationStatus.WARNING:
      return <StatusLabel color="yellow">{SetUpperCase(StationStatus.WARNING)}</StatusLabel>;
    case StationStatus.INACTIVE:
      return <StatusLabel color="gray">{SetUpperCase(StationStatus.INACTIVE)}</StatusLabel>;
    case StationStatus.DELETED:
      return <StatusLabel color="red">{SetUpperCase(StationStatus.DELETED)}</StatusLabel>;
    case StationStatus.ALERT:
      return <StatusLabel color="alert">{SetUpperCase(StationStatus.ALERT)}</StatusLabel>;
    case StationStatus.NO_POWER:
      return <StatusLabel color="dark">{SetUpperCase(StationStatus.NO_POWER)}</StatusLabel>;
    default:
      return <StatusLabel>{status}</StatusLabel>;
  }
};

export const getLockerStatusColor = (status?: EvLockerStatus) => {
  switch (status) {
    case EvLockerStatus.EMPTY:
      return <StatusLabel color="gray">{SetUpperCase(EvLockerStatus.EMPTY)}</StatusLabel>;
    case EvLockerStatus.INACTIVE:
      return <StatusLabel color="red">{SetUpperCase(EvLockerStatus.INACTIVE)}</StatusLabel>;
    case EvLockerStatus.FAILED:
      return <StatusLabel color="red">{SetUpperCase(EvLockerStatus.FAILED)}</StatusLabel>;
    case EvLockerStatus.CHARGING:
      return <StatusLabel color="yellow">{SetUpperCase(EvLockerStatus.CHARGING)}</StatusLabel>;
    case EvLockerStatus.CHARGED:
      return <StatusLabel color="green">{SetUpperCase(EvLockerStatus.CHARGED)}</StatusLabel>;
    case EvLockerStatus.RESERVED:
      return <StatusLabel color="orange">{SetUpperCase(EvLockerStatus.RESERVED)}</StatusLabel>;
    case EvLockerStatus.PENDING:
      return <StatusLabel color="brown">{SetUpperCase(EvLockerStatus.PENDING)}</StatusLabel>;
    default:
      return <StatusLabel>{status}</StatusLabel>;
  }
};

export const getEvLockerActionColor = (status?: EvLockerAction) => {
  switch (status) {
    case EvLockerAction.ACTIVATE:
      return <StatusLabel color="green">{SetUpperCase(EvLockerAction.ACTIVATE)}</StatusLabel>;
    case EvLockerAction.INACTIVATE:
      return <StatusLabel color="red">{SetUpperCase(EvLockerAction.INACTIVATE)}</StatusLabel>;
    case EvLockerAction.MAINTAIN:
      return <StatusLabel color="brown">{SetUpperCase(EvLockerAction.MAINTAIN)}</StatusLabel>;
    case EvLockerAction.INSERT:
      return <StatusLabel color="lightBlue">{SetUpperCase(EvLockerAction.INSERT)}</StatusLabel>;
    case EvLockerAction.TAKEOUT:
      return <StatusLabel color="gray">{SetUpperCase(EvLockerAction.TAKEOUT)}</StatusLabel>;
    case EvLockerAction.CANCEL:
      return <StatusLabel color="red">{SetUpperCase(EvLockerAction.CANCEL)}</StatusLabel>;
    case EvLockerAction.GET_UPDATE:
      return <StatusLabel color="brown">{SetUpperCase(EvLockerAction.GET_UPDATE)}</StatusLabel>;
    case EvLockerAction.OPEN:
      return <StatusLabel color="green">{SetUpperCase(EvLockerAction.OPEN)}</StatusLabel>;
    case EvLockerAction.RESERVE:
      return <StatusLabel color="orange">{SetUpperCase(EvLockerAction.RESERVE)}</StatusLabel>;
    case EvLockerAction.SEND_UPDATE:
      return <StatusLabel color="blue">{SetUpperCase(EvLockerAction.SEND_UPDATE)}</StatusLabel>;
    default:
      return <StatusLabel>{status}</StatusLabel>;
  }
};

export const getStationActionColor = (status?: StationAction) => {
  switch (status) {
    case StationAction.ACTIVATE:
      return <StatusLabel color="green">{SetUpperCase(StationAction.ACTIVATE)}</StatusLabel>;
    case StationAction.INACTIVATE:
      return <StatusLabel color="red">{SetUpperCase(StationAction.INACTIVATE)}</StatusLabel>;
    case StationAction.GET_STATUS:
      return <StatusLabel color="brown">{SetUpperCase(StationAction.GET_STATUS)}</StatusLabel>;
    case StationAction.UPDATE_POWER_METER:
      return (
        <StatusLabel color="blue">{SetUpperCase(StationAction.UPDATE_POWER_METER)}</StatusLabel>
      );
    case StationAction.RETURN:
      return <StatusLabel color="gray">{SetUpperCase(StationAction.RETURN)}</StatusLabel>;
    case StationAction.CANCEL:
      return <StatusLabel color="red">{SetUpperCase(StationAction.CANCEL)}</StatusLabel>;
    case StationAction.GET_UPDATE:
      return <StatusLabel color="brown">{SetUpperCase(StationAction.GET_UPDATE)}</StatusLabel>;
    case StationAction.OPEN:
      return <StatusLabel color="green">{SetUpperCase(StationAction.OPEN)}</StatusLabel>;
    case StationAction.RESERVE:
      return <StatusLabel color="orange">{SetUpperCase(StationAction.RESERVE)}</StatusLabel>;
    case StationAction.SEND_UPDATE:
      return <StatusLabel color="blue">{SetUpperCase(StationAction.SEND_UPDATE)}</StatusLabel>;
    case StationAction.LOGIN:
      return <StatusLabel color="lightBlue">{SetUpperCase(StationAction.LOGIN)}</StatusLabel>;
    case StationAction.OCCUPIED:
      return <StatusLabel color="gray">{SetUpperCase(StationAction.OCCUPIED)}</StatusLabel>;
    case StationAction.PRINT:
      return <StatusLabel color="orange">{SetUpperCase(StationAction.PRINT)}</StatusLabel>;
    case StationAction.REGISTER:
      return <StatusLabel color="blue">{SetUpperCase(StationAction.REGISTER)}</StatusLabel>;
    case StationAction.UNREGISTER:
      return <StatusLabel color="gray">{SetUpperCase(StationAction.UNREGISTER)}</StatusLabel>;
    case StationAction.RESTART:
      return <StatusLabel color="gray">{SetUpperCase(StationAction.RESTART)}</StatusLabel>;
    default:
      return <StatusLabel>{status}</StatusLabel>;
  }
};

export const getActionStatusColor = (status?: EvLockerActionStatus) => {
  switch (status) {
    case EvLockerActionStatus.SUCCESS:
      return <StatusLabel color="green">{SetUpperCase(EvLockerActionStatus.SUCCESS)}</StatusLabel>;
    case EvLockerActionStatus.FAILED:
      return <StatusLabel color="red">{SetUpperCase(EvLockerActionStatus.FAILED)}</StatusLabel>;
    default:
      return <StatusLabel>{status}</StatusLabel>;
  }
};

export const getBatteryStatusColor = (
  status?: NiuBatteryStatus | UniversalBatteryStatus,
  isFull?: boolean,
) => {
  switch (status) {
    case NiuBatteryStatus.NO_LOAD:
      return (
        <StatusLabel key={status} color="green">
          {SetUpperCase(NiuBatteryStatus.NO_LOAD)}
        </StatusLabel>
      );
    case NiuBatteryStatus.DISCHARGE:
      return (
        <StatusLabel key={status} color="yellow">
          {SetUpperCase(NiuBatteryStatus.DISCHARGE)}
        </StatusLabel>
      );
    case NiuBatteryStatus.CHARGE:
      return (
        <StatusLabel key={status} color="yellow">
          {SetUpperCase(NiuBatteryStatus.CHARGE)}
        </StatusLabel>
      );
    case NiuBatteryStatus.OVER_CHARGE:
      return (
        <StatusLabel key={status} color="orange">
          {SetUpperCase(NiuBatteryStatus.OVER_CHARGE)}
        </StatusLabel>
      );
    case NiuBatteryStatus.OVER_DISCHARGE:
      return (
        <StatusLabel key={status} color="orange">
          {SetUpperCase(NiuBatteryStatus.OVER_DISCHARGE)}
        </StatusLabel>
      );
    case NiuBatteryStatus.OVER_CURRENT_CHARGE:
      return (
        <StatusLabel key={status} color="purple">
          {SetUpperCase(NiuBatteryStatus.OVER_CURRENT_CHARGE)}
        </StatusLabel>
      );
    case NiuBatteryStatus.OVER_CURRENT_DISCHARGE:
      return (
        <StatusLabel key={status} color="purple">
          {SetUpperCase(NiuBatteryStatus.OVER_CURRENT_DISCHARGE)}
        </StatusLabel>
      );
    case NiuBatteryStatus.OVERHEAT:
      return (
        <StatusLabel key={status} color="red">
          {SetUpperCase(NiuBatteryStatus.OVERHEAT)}
        </StatusLabel>
      );
    case NiuBatteryStatus.SUPER_COOL:
      return (
        <StatusLabel key={status} color="lightBlue">
          {SetUpperCase(NiuBatteryStatus.SUPER_COOL)}
        </StatusLabel>
      );
    case NiuBatteryStatus.OTHER_EXCEPTION:
      return (
        <StatusLabel key={status} color="brown">
          {SetUpperCase(NiuBatteryStatus.OTHER_EXCEPTION)}
        </StatusLabel>
      );
    case NiuBatteryStatus.SHORT:
      return (
        <StatusLabel key={status} color="red">
          {SetUpperCase(NiuBatteryStatus.SHORT)}
        </StatusLabel>
      );
    case NiuBatteryStatus.WATER:
      return (
        <StatusLabel key={status} color="blue">
          {SetUpperCase(NiuBatteryStatus.WATER)}
        </StatusLabel>
      );
    case NiuBatteryStatus.MOS_DAMAGE:
      return (
        <StatusLabel key={status} color="brown">
          {SetUpperCase(NiuBatteryStatus.MOS_DAMAGE)}
        </StatusLabel>
      );
    case NiuBatteryStatus.UNKNOWN:
      return (
        <StatusLabel key={status} color="gray">
          {SetUpperCase(NiuBatteryStatus.UNKNOWN)}
        </StatusLabel>
      );
    case UniversalBatteryStatus.BMS_FAULT:
      return (
        <StatusLabel key={status} color="gray">
          {SetUpperCase(UniversalBatteryStatus.BMS_FAULT)}
        </StatusLabel>
      );
    case UniversalBatteryStatus.OK:
      return (
        <StatusLabel key={status} color={isFull ? 'green' : 'yellow'}>
          {SetUpperCase(UniversalBatteryStatus.OK)}
        </StatusLabel>
      );
    case UniversalBatteryStatus.OVER_CURRENT:
      return (
        <StatusLabel key={status} color="gray">
          {SetUpperCase(UniversalBatteryStatus.OVER_CURRENT)}
        </StatusLabel>
      );
    case UniversalBatteryStatus.OVER_TEMP:
      return (
        <StatusLabel key={status} color="gray">
          {SetUpperCase(UniversalBatteryStatus.OVER_TEMP)}
        </StatusLabel>
      );
    case UniversalBatteryStatus.OVER_VOLT:
      return (
        <StatusLabel key={status} color="gray">
          {SetUpperCase(UniversalBatteryStatus.OVER_VOLT)}
        </StatusLabel>
      );
    case UniversalBatteryStatus.UNBALANCED:
      return (
        <StatusLabel key={status} color="gray">
          {SetUpperCase(UniversalBatteryStatus.UNBALANCED)}
        </StatusLabel>
      );
    case UniversalBatteryStatus.UNDER_CURRENT:
      return (
        <StatusLabel key={status} color="gray">
          {SetUpperCase(UniversalBatteryStatus.UNDER_CURRENT)}
        </StatusLabel>
      );
    case UniversalBatteryStatus.UNDER_TEMP:
      return (
        <StatusLabel key={status} color="gray">
          {SetUpperCase(UniversalBatteryStatus.UNDER_TEMP)}
        </StatusLabel>
      );
    case UniversalBatteryStatus.UNDER_VOLT:
      return (
        <StatusLabel key={status} color="gray">
          {SetUpperCase(UniversalBatteryStatus.UNDER_VOLT)}
        </StatusLabel>
      );
    default:
      return <StatusLabel key={status}>{status}</StatusLabel>;
  }
};

export const getChargerStatusColor = (status?: NiuChargerStatus | UniversalChargerStatus) => {
  switch (status) {
    case NiuChargerStatus.NORMAL_CHARGE:
      return (
        <StatusLabel color="green">{SetUpperCase(NiuChargerStatus.NORMAL_CHARGE)}</StatusLabel>
      );
    case NiuChargerStatus.SLOW_RECOVERY:
      return (
        <StatusLabel color="orange">{SetUpperCase(NiuChargerStatus.SLOW_RECOVERY)}</StatusLabel>
      );
    case NiuChargerStatus.NO_POWER:
      return <StatusLabel color="lightBlue">{SetUpperCase(NiuChargerStatus.NO_POWER)}</StatusLabel>;
    case NiuChargerStatus.IDLE:
      return <StatusLabel color="gray">{SetUpperCase(NiuChargerStatus.IDLE)}</StatusLabel>;
    case NiuChargerStatus.FULL:
      return <StatusLabel color="green">{SetUpperCase(NiuChargerStatus.FULL)}</StatusLabel>;
    case NiuChargerStatus.FAST_RECOVERY:
      return (
        <StatusLabel color="yellow">{SetUpperCase(NiuChargerStatus.FAST_RECOVERY)}</StatusLabel>
      );
    case NiuChargerStatus.ERROR:
      return <StatusLabel color="red">{SetUpperCase(NiuChargerStatus.ERROR)}</StatusLabel>;
    case NiuChargerStatus.SOFT_FULL:
      return (
        <StatusLabel color="yellowgreen">{SetUpperCase(NiuChargerStatus.SOFT_FULL)}</StatusLabel>
      );
    case NiuChargerStatus.UNKNOWN:
      return <StatusLabel color="gray">{SetUpperCase(NiuChargerStatus.UNKNOWN)}</StatusLabel>;
    case NiuChargerStatus.WARNING:
      return <StatusLabel color="orange">{SetUpperCase(NiuChargerStatus.WARNING)}</StatusLabel>;
    case NiuChargerStatus.DISABLED:
      return <StatusLabel color="orange">{SetUpperCase(NiuChargerStatus.DISABLED)}</StatusLabel>;
    case NiuChargerStatus.ERR_FLAG:
      return <StatusLabel color="gray">{SetUpperCase(NiuChargerStatus.ERR_FLAG)}</StatusLabel>;
    case NiuChargerStatus.ERR_NORM_TO:
      return <StatusLabel color="gray"> {SetUpperCase(NiuChargerStatus.ERR_NORM_TO)}</StatusLabel>;
    case NiuChargerStatus.ERR_RS485_FAULT:
      return (
        <StatusLabel color="gray">{SetUpperCase(NiuChargerStatus.ERR_RS485_FAULT)}</StatusLabel>
      );
    case NiuChargerStatus.ERR_SLOW_TO:
      return <StatusLabel color="gray">{SetUpperCase(NiuChargerStatus.ERR_SLOW_TO)}</StatusLabel>;
    case NiuChargerStatus.ERR_UNB:
      return <StatusLabel color="gray">{SetUpperCase(NiuChargerStatus.ERR_UNB)}</StatusLabel>;
    case NiuChargerStatus.WARN_FLAG:
      return <StatusLabel color="gray">{SetUpperCase(NiuChargerStatus.WARN_FLAG)}</StatusLabel>;
    case UniversalChargerStatus.CHARGE_1:
      return (
        <StatusLabel color="yellow">{SetUpperCase(UniversalChargerStatus.CHARGE_1)}</StatusLabel>
      );
    case UniversalChargerStatus.CHARGE_2:
      return (
        <StatusLabel color="yellow">{SetUpperCase(UniversalChargerStatus.CHARGE_2)}</StatusLabel>
      );
    case UniversalChargerStatus.DISABLE:
      return <StatusLabel color="gray">{SetUpperCase(UniversalChargerStatus.DISABLE)}</StatusLabel>;
    case UniversalChargerStatus.DOOR_CLOSE:
      return (
        <StatusLabel color="gray">{SetUpperCase(UniversalChargerStatus.DOOR_CLOSE)}</StatusLabel>
      );
    case UniversalChargerStatus.DOOR_OPEN:
      return (
        <StatusLabel color="gray">{SetUpperCase(UniversalChargerStatus.DOOR_OPEN)}</StatusLabel>
      );
    case UniversalChargerStatus.ERR_BAT_FAULT:
      return (
        <StatusLabel color="gray">{SetUpperCase(UniversalChargerStatus.ERR_BAT_FAULT)}</StatusLabel>
      );
    case UniversalChargerStatus.ERR_BAT_RS485_FAULT:
      return (
        <StatusLabel color="gray">
          {SetUpperCase(UniversalChargerStatus.ERR_BAT_RS485_FAULT)}
        </StatusLabel>
      );
    case UniversalChargerStatus.ERR_CHG_FAULT:
      return (
        <StatusLabel color="gray">{SetUpperCase(UniversalChargerStatus.ERR_CHG_FAULT)}</StatusLabel>
      );
    case UniversalChargerStatus.ERR_CHG_TIMEOUT:
      return (
        <StatusLabel color="gray">
          {SetUpperCase(UniversalChargerStatus.ERR_CHG_TIMEOUT)}
        </StatusLabel>
      );
    case UniversalChargerStatus.ERR_PCHG_TIMEOUT:
      return (
        <StatusLabel color="gray">
          {SetUpperCase(UniversalChargerStatus.ERR_PCHG_TIMEOUT)}
        </StatusLabel>
      );
    case UniversalChargerStatus.ERR_RCHG_TIMEOUT:
      return (
        <StatusLabel color="gray">
          {SetUpperCase(UniversalChargerStatus.ERR_RCHG_TIMEOUT)}
        </StatusLabel>
      );
    case UniversalChargerStatus.ERR_TEMP_TIMEOUT:
      return (
        <StatusLabel color="gray">
          {SetUpperCase(UniversalChargerStatus.ERR_TEMP_TIMEOUT)}
        </StatusLabel>
      );
    case UniversalChargerStatus.NO_CHARGER:
      return (
        <StatusLabel color="gray">{SetUpperCase(UniversalChargerStatus.NO_CHARGER)}</StatusLabel>
      );
    case UniversalChargerStatus.PRE_CHARGE:
      return (
        <StatusLabel color="gray">{SetUpperCase(UniversalChargerStatus.PRE_CHARGE)}</StatusLabel>
      );
    case UniversalChargerStatus.RECHARGE:
      return (
        <StatusLabel color="gray">{SetUpperCase(UniversalChargerStatus.RECHARGE)}</StatusLabel>
      );
    case UniversalChargerStatus.R_MEAS:
      return <StatusLabel color="gray">{SetUpperCase(UniversalChargerStatus.R_MEAS)}</StatusLabel>;
    case UniversalChargerStatus.WAIT_TEMP_BAT:
      return (
        <StatusLabel color="gray">{SetUpperCase(UniversalChargerStatus.WAIT_TEMP_BAT)}</StatusLabel>
      );
    case UniversalChargerStatus.WAIT_TEMP_CHG:
      return (
        <StatusLabel color="gray">{SetUpperCase(UniversalChargerStatus.WAIT_TEMP_CHG)}</StatusLabel>
      );
    default:
      return <StatusLabel>{status}</StatusLabel>;
  }
};
